import React from 'react';
import { Card, CardContent, Typography, Grid } from '@material-ui/core';
import { Field } from 'redux-form';
import { formatCurrency } from '../../utilities/formatting/data_normalizations';
import { validateCurrency } from '../../utilities/form_validation';
import { Strings as S } from '../../assets/common/strings';
import { FormTextField } from '../../utilities/forms';

interface PremiumInfoCardProps { }

interface PremiumInfoCardState { }

export class PremiumInfoCard extends React.Component<
	PremiumInfoCardProps,
	PremiumInfoCardState
	> {
	render() {
		return (
			<div>
				<Typography variant="h5" style={{ margin: '20px 0 5px 20px' }}>
					{S.ProductPremiumInfoEditOptions.PremiumInfo}
				</Typography>
				<Card style={styles.cardStyle}>
					<CardContent>
						<Grid container>
							<Grid item xs={12} sm={6}>
								<Field
									name="application.annualPremium"
									label={S.ProductPremiumInfoEditOptions.AnnualPremium}
									component={FormTextField}
									validate={validateCurrency}
									normalize={formatCurrency}
									style={styles.editListItem}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<Field
									name="application.monthlyPremium"
									label={S.ProductPremiumInfoEditOptions.MonthlyPremium}
									component={FormTextField}
									validate={validateCurrency}
									normalize={formatCurrency}
									style={styles.editListItem}
								/>
							</Grid>
						</Grid>
						<Grid container>
							<Grid item xs={12} sm={6}>
								<Field
									name="application.annualFederalSubsidy"
									label={S.ProductPremiumInfoEditOptions.AnnualFederalSubsidy}
									component={FormTextField}
									validate={validateCurrency}
									normalize={formatCurrency}
									style={styles.editListItem}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<Field
									name="application.monthlyFederalSubsidy"
									label={S.ProductPremiumInfoEditOptions.MonthlyFederalSubsidy}
									component={FormTextField}
									validate={validateCurrency}
									normalize={formatCurrency}
									style={styles.editListItem}
								/>
							</Grid>
						</Grid>
						<Grid container>
							<Grid item xs={12} sm={6}>
								<Field
									name="application.annualNetCost"
									label={S.ProductPremiumInfoEditOptions.AnnualNetCost}
									component={FormTextField}
									validate={validateCurrency}
									normalize={formatCurrency}
									style={styles.editListItem}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<Field
									name="application.monthlyNetCost"
									label={S.ProductPremiumInfoEditOptions.MonthlyNetCost}
									component={FormTextField}
									validate={validateCurrency}
									normalize={formatCurrency}
									style={styles.editListItem}
								/>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</div>
		);
	}
}

const styles: { [key: string]: React.CSSProperties } = {
	cardStyle: {
		margin: 10,
		marginTop: 0,
	},
	editListItem: {
		marginLeft: 10,
		width: '90%',
	},
};
